import { render, staticRenderFns } from "./RemitosDetalle.vue?vue&type=template&id=965d51b8&scoped=true&"
import script from "./RemitosDetalle.vue?vue&type=script&lang=js&"
export * from "./RemitosDetalle.vue?vue&type=script&lang=js&"
import style0 from "./RemitosDetalle.vue?vue&type=style&index=0&id=965d51b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965d51b8",
  null
  
)

export default component.exports